import React, { Component } from 'react';
import {auth, firebase} from '../firebase';
import moment from 'moment'
import {Alert,Modal,Button} from 'react-bootstrap'
import ModalConnection from './ModalConnectionSubscribe';
import {doSignOut} from '../authDB';


// id dev
//const idRestaurant="-LHCvfvi5Zis0rJffGlg"
// id prod
const idRestaurant="-L8HPl47r9qChaUm_6uU"


class App extends Component {
    constructor(){
        super();
        this.state = {
            points : {},
            program:{},
            profile:{},
            converted_point:0,
            insuffisant_solde:false,
            show:false,
            grid_points:0,
            grid_money:0,
            minimum_to_convert:0

    
    };
     this.increment=this.increment.bind(this)
     this.decrement=this.decrement.bind(this)
     this.convert=this.convert.bind(this)
     this.handleClose=this.handleClose.bind(this)
     this.grid_list=this.grid_list.bind(this)
     this.point_conversion=this.point_conversion.bind(this)
      }
      show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }
    componentDidMount(){
        let uid = JSON.parse(localStorage.getItem('user')).uid;
        var ref= firebase.database().ref(`/loyalty_points/`);
        var ref2= firebase.database().ref(`/loyalty_program/${idRestaurant}`);
        var ref3= firebase.database().ref(`/stores_profiles/${idRestaurant}`);


        ref.orderByChild('user_uid').equalTo(uid)
        .on('child_added',(data)=>{
         // console.log(data.val())
    if(data.val().store_id===idRestaurant)
          this.setState(
            {points:{...data.val(),key:data.key}
        })})
        ref.orderByChild('user_uid').equalTo(uid)
        .on('child_changed',(data)=>{
         // console.log(data.val())
    if(data.val().store_id===idRestaurant)
          this.setState(
            {points:{...data.val(),key:data.key}
        })})
        ref2.on("value",(data)=>{
            console.log(data.val())
            this.setState(
                {program:{...data.val(),key:data.key},converted_point:data.val().minimum_to_convert?data.val().minimum_to_convert:0,minimum_to_convert:data.val().minimum_to_convert?data.val().minimum_to_convert:0}
              )

        })
        ref3.on("value",(data)=>{
            console.log(data.val())
            this.setState(
                {profile:data.val()}
              )

        })
    
      }
      increment()
      {
          if(this.state.points)
          if(this.state.converted_point<this.state.points.points)
          
          this.setState({converted_point:this.state.converted_point+10})

          
          

      }
      decrement(){
        if(this.state.points)
        if(this.state.converted_point>0)
        this.setState({converted_point:this.state.converted_point-10})
      }
      point_conversion(e){
  console.log(parseInt(e.target.value,10))
  console.log(this.state.program.minimum_to_convert)
  var v1=parseInt(e.target.value,10)
  var v2=parseInt(this.state.program.minimum_to_convert,10)
  console.log(v2>10   )


        if(parseInt(e.target.value,10) >= this.state.program.minimum_to_convert)
        this.setState({converted_point: parseInt(e.target.value)})
       
      }
      convert_grille(point,money){
        const {converted_point,program,points}=this.state
        this.setState({insuffisant_solde:false})
        let uid = JSON.parse(localStorage.getItem('user')).uid;
        var ref= firebase.database().ref(`/loyalty_points/${points.key}`);
        var ref3= firebase.database().ref(`/transactions/`);
        var type="points_converted"
      

          
          var res_added_money=money
          var res_point_after=parseInt(points.points,10)-parseInt(point,10) 
          console.log(point)
          console.log(points.points)
          console.log(res_point_after)
          var res_money_after=points.balance+res_added_money
if(res_point_after>=0)
         { ref.update({points:res_point_after,balance:res_money_after})
           .then(()=>{
            ref3.push({created_at:firebase.database.ServerValue.TIMESTAMP ,
                money_amount:res_added_money,points:point,store_id:idRestaurant,type:type,user_uid:uid})
        

           })
           .catch((e)=>{
            
               console.log(e)
           })}
           else{
               this.setState({insuffisant_solde:true})
           }




      }

      grid_list(){
          var items=[]
          const{program}=this.state

          var prog = Object
          .keys(program.prizes_grid || [])
          .sort((a, b) => {
            if (program.prizes_grid[b].points > program.prizes_grid[a].points) {
              return -1;
            }
            if (program.prizes_grid[b].points < program.prizes_grid[a].points) {
              return 1;
            }// 
            return 0;
          })
          .reduce((_sortedObj, key) => ([
            ..._sortedObj,
            program.prizes_grid[key]
          ]), [])


          Object.keys(prog||[]).forEach((v,e)=>{
              let money=prog[v].money
              let pointss=prog[v].points
            items.push(
                <li>
                                                    <a style={{color:"#ffffff" ,fontSize:25,cursor: "pointer"}}  onClick={()=>
                                                        
                                                      {
                                                        const {converted_point,program,points}=this.state  
                                                        var res_added_money=money
                                                        var res_point_after=parseInt(points.points,10)-parseInt(pointss,10) 
                                                     
                                                        var res_money_after=points.balance+res_added_money
                                                        if(res_point_after>=0)
                                                       { this.setState({show2:true,grid_money:money,grid_points:pointss})
                                                        }
                                                        else
                                                        {
                                                            
                                                            this.setState({insuffisant_solde:true})

                                                        }
                                                        
                                                        } }
                                                        >
                                                    
                                                  {pointss} PTS  <i className="fa fa-arrows-h"/> {money} TND </a>
                                                </li>
                                                
            )
            items.push(<br/>)
            items.push(<br/>)
          })

          return items
      }

      convert(){
        const {converted_point,program,points}=this.state
        this.setState({insuffisant_solde:false})
        let uid = JSON.parse(localStorage.getItem('user')).uid;
        var ref= firebase.database().ref(`/loyalty_points/${points.key}`);
        var ref3= firebase.database().ref(`/transactions/`);
        var type="points_converted"
      

          
          var res_added_money=converted_point*program.point_to_money
          var res_point_after=points.points-converted_point
          var res_money_after=points.balance+res_added_money
if(res_point_after>=0)
         { ref.update({points:res_point_after,balance:res_money_after})
           .then(()=>{
            ref3.push({created_at:firebase.database.ServerValue.TIMESTAMP,
                money_amount:res_added_money,points:converted_point,store_id:idRestaurant,type:type,user_uid:uid})
        

           })
           .catch((e)=>{
            
               console.log(e)
           })}
           else{
               alert('its')
               this.setState({insuffisant_solde:true})
           }




      }
      handleClose(){
          this.setState({show:false})
      }
      handleClose2(){
        this.setState({show2:false})
    }

  render() {
      console.log(this.state)
    return (
   <div>
       
       <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                         {/*    <li className="">
                                            <a  href="/about">À propos</a>
    </li>*/}
                                        <li className="">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>
        <section className="page-title">
    <div className="container">
        <h2 className="title">
        MES POINTS DE FIDÉLITÉ
        </h2>
        <ul className="brdcrumb clearfix">
            <li>
                <a href="/">Accueil</a>
            </li>
           
            <li className="current">
                Mes points de fidélité
            </li>
        </ul>
    </div>
</section>
<section className="section-padding video-section">
<div className="container">
<div style={{margin:"0% 20% 0% 20%"}} class="row food-card">
<div  class="col-xs-12">
                                <div class="feature">
                                    

{(this.state.insuffisant_solde)?<Alert bsStyle="danger">
  <strong>Solde Insuffisant!</strong> 
</Alert>:null}
{(this.state.program)?null:<Alert style={{fontSize:20}} bsStyle="info">
Scannez le code QR présent dans le ticket Bistro 73 depuis notre application mobile pour recevoir vos premiers points.</Alert>}

</div>
</div>
        {(this.state.program)?<div>
                             <div style={{backgroundColor:"#808080"}}  class="col-xs-12 food-card">
                                <div class="feature">
                                    <div class="icon">
                                    <a href="#">
                                    <img src={this.state.profile.logo?this.state.profile.logo.url:""} height="100" with="100" alt="special dish"/>

                                   
                                </a>
                                    </div>
                                    <div class="feature-text">
                                   
<h1 style={{color:"#ffffff"}} >


    {this.state.profile.name}

   
</h1>
<br/>
{(this.state.program.type==="simple_equivalence")?
<h2 style={{color:"#ffad18", fontFamily:"roboto" }} >
    (  1 PTS  <i style={{fontSize:30}} className="fa fa-arrows-h"/> {this.state.program.point_to_money} TND )
   
</h2>:null}
</div>
                                  
                                </div>
                            </div>
                            <hr style={{backgroundColor:"#ffffff"}}/>
                       
                       <div style={{backgroundColor:"#808080"}}  class="col-xs-12 food-card">
                            <div  class="col-xs-6">
                                <div class="feature">
                                    <div class="icon">
                                        <i class="fa fa-gift"></i>
                                    </div>
                                    <div class="feature-text">

                                        <h5 class="title">
                                            <span class="">{this.state.points.points?this.state.points.points:0}</span>
                                            PTS
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div  class="col-xs-6">
                                <div class="feature">
                                    <div class="icon">
                                        <i class="fa fa-money"></i>
                                    </div>
                                    <div class="feature-text">
                                        <h5 class="title">
                                            <span class="">{this.state.points.balance?this.state.points.balance.toFixed(3):0}</span>TND
                                        </h5>
                                    </div>
                                </div>
                            </div></div>
                            <hr/>
{(this.state.program.type==="simple_equivalence")?
                            <div style={{backgroundColor:"#808080"}}  class="col-xs-12 food-card">
                            <div style={{fontSize:40,color:"#ffffff"}} className="col-xs-12 ">
               {/*<center>   <i style={{color:"#ffad18",marginRight:20}} className="fa fa-minus-square countIcon " aria-hidden="true" onClick= {this.decrement}></i>
                  {this.state.converted_point}  
                  <i style={{marginLeft:5,marginRight:5,color:"#ffad18",marginLeft:20}} className="fa fa-plus-square countIcon " aria-hidden="true" onClick={this.increment}  ></i>
        </center>*/}
        <center>   
                  {this.state.converted_point}  PTS
                </center>
         <input type="range" min={this.state.points.minimum_to_convert} max={this.state.points.points} value={this.state.converted_point } 
         class="slider"  id="myRange" onChange={(e)=>{this.point_conversion(e)}} />
                
                </div>
                <div style={{fontSize:40}} className="col-xs-12 ">
               <center> 
                   <button className="btn-custom" style={{backgroundColor:"#32b774",color:"#ffffff",marginTop:40,fontSize:30, width:"60%"}} onClick={()=>
                    
                 {
                    const {converted_point,program,points}=this.state

                    var res_added_money=converted_point*program.point_to_money
                    var res_point_after=points.points-converted_point
                    var res_money_after=points.balance+res_added_money   
                    if(res_point_after>=0)
               {
                    this.setState({show:true})
                }
                else{
                    this.setState({insuffisant_solde:true})
                }
                
                
                }
                    
                    
                    } > Convertir </button>
                    </center>
                
                </div>  
                
                </div>:null} 
                {(this.state.program.type==="grid")?<div style={{backgroundColor:"#808080"}}  class="col-xs-12 food-card">
                <div style={{marginLeft:30}} class="blog-tags m-top20">

                                            <ul>
                                              
                                                {this.grid_list()}
                                            </ul>
                                        </div>

                                         </div>:null}</div>:null}
                          
                           
                        </div>
                         </div>

   <Modal show={this.state.show2} onHide={this.handleClose2}  >
                        <Modal.Header closeButton>
          <Modal.Title id= "titleFood">
           
            Confirmation du convertion
                
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

<div style={{fontFamily:"sans-serif",fontSize:30}}>
Est -vous sûre de Convertir ce Montant
</div>

        </Modal.Body>
                        <Modal.Footer>
          <Button className="btn btn-warning" id ="addCart"  onClick= {()=>{this.handleClose2()}}>Annuler</Button>
          <Button className=" btn btn-primary" id ="addCart"  onClick= {()=>{this.convert_grille(this.state.grid_points,this.state.grid_money)
          this.handleClose2()}}>Convertir</Button>

        </Modal.Footer>
        </Modal>

                        <Modal show={this.state.show} onHide={this.handleClose}  >
                        <Modal.Header closeButton>
          <Modal.Title id= "titleFood">
           
            Confirmation du convertion
                
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

<div style={{fontFamily:"sans-serif",fontSize:30}}>
Est -vous sûre de Convertir ce Montant
</div>

        </Modal.Body>
                        <Modal.Footer>
          <Button className="btn btn-warning" id ="addCart"  onClick= {()=>{this.handleClose()}}>Annuler</Button>
          <Button className=" btn btn-primary" id ="addCart"  onClick= {()=>{this.convert()
          this.handleClose()}}>Convertir</Button>

        </Modal.Footer>
        </Modal>
                        
</section>
<ModalConnection ref="ModalConnection"/>

    </div>


   
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/loyalty.js